const sc = process.env.VUE_APP_SC;
const url = window.location.origin;
// const wo = process.env.VUE_APP_WO;

/* export const buyer = [
  {
    name: '我的集采',
    cAhref: `${sc}groupPurchase/my/toMyNxinGroupPurchase.do?appid=1`,
  },
  {
    name: '我的余额',
    cAhref: `${sc}payment/margin/myMargin.do?appid=1`,
  },
  {
    name: '支付账户',
    cAhref: `${sc}payment/account/listPage.do?appid=1`,
  },
  {
    name: '我的收藏',
    cAhref: `${sc}member/favorite/listPage.do?appid=1`,
  },
  {
    name: '账单',
    cAhref: `${sc}bill/page.do?appid=1`,
  },
  {
    name: '地址信息',
    cAhref: `${sc}member/delivery/listPage.do?appid=1`,
  },
  {
    name: '我的企业',
    cAhref: `${sc}member/company/listPage.do?appid=1`,
  },
  {
    name: '个人中心',
    cAhref: wo,
  },
]; */
export const buyer = [
  {
    name: '账单',
    cAhref: `${sc}bill/page.do?yynid=`,
  },
  {
    name: '地址信息',
    cAhref: `${sc}member/delivery/listPage.do?yynid=`,
  },
  {
    name: '专属货品',
    // cAhref: `${sc}recommend/page.do?yynid=`,
    cAhref: `${url}/order?yynid=`,
  },
  {
    name: '我的优惠券',
    cAhref: `${sc}cashCoupon/pc/toPage.do?yynid=`,
  },
];

export const seller = [
  {
    name: '店铺管理',
    cAhref: `${sc}mj/queryShopMJ.do?yynid=`,
  },
  {
    name: '店铺装修',
    child: [
      {
        name: '店铺导航栏',
        cAhref: `${sc}satnav/toShopSatnav.do?yynid=`,
      },
      {
        name: '货品分类管理',
        cAhref: `${sc}classify/toShopClassify.do?yynid=`,
      },
      {
        name: '首页装修',
        cAhref: `${sc}index/toIndexCarouselFiguer.do?yynid=`,
      },
    ],
  },
  {
    name: '货品管理',
    cAhref: `${sc}mj/toGoodsMJ.do?yynid=`,
  },
  {
    name: '订单管理',
    cAhref: `${sc}mj/order/manage/orderList.do?yynid=`,
  },
  {
    name: '配送管理',
    cAhref: `${sc}mj/toOtherAddr.do?yynid=`,
  },
  {
    name: '运费管理',
    cAhref: `${sc}mj/freight/toFreightListEtp.do?yynid=`,
  },
  {
    name: '客户管理',
    child: [
      {
        name: '客户列表',
        cAhref: `${sc}mj/customer/toCustomerNew.do?yynid=`,
      },
      {
        name: '分组管理',
        cAhref: `${sc}mj/customer/toCustomerGroup.do?yynid=`,
      },
    ],
  },
  {
    name: '价格方案',
    cAhref: `${sc}mj/priceScheme/toPriceListPage.do?yynid=`,
  },
  /* {
    name: '促销管理',
    cAhref: `${sc}mj/promotion/toSelectList.do?yynid=`,
  }, */
  {
    name: '店铺优惠券',
    cAhref: `${sc}mj/coupon/toShopCoupon.do?yynid=`,
  },
  {
    name: '我的余额',
    cAhref: `${sc}payment/margin/myMargin.do?yynid=`,
  },
  {
    name: '账单',
    cAhref: `${sc}mj/bill/page.do?yynid=`,
  },
  {
    name: '货款结算',
    cAhref: `${sc}mj/invoiceStatement/myInvoiceStatement.do?yynid=`,
  },
  {
    name: '促销活动管理',
    cAhref: `${sc}mj/promotion/toSelectList.do?yynid=`,
  },
  {
    name: '套餐管理',
    cAhref: `${sc}mj/toPackageGoodsMJ.do?yynid=`,
  },
  /* {
    name: '代销管理',
    cAhref: `${sc}mj/toGoodsDealershipsList.do?yynid=`,
  },
  {
    name: '我的返利',
    cAhref: `${sc}mj/rebate/myRebate?yynid=`,
  }, */
  /* {
    name: '权限分配',
    cAhref: `${sc}mj/member/getAssign.do?yynid=`,
  }, */
  /* {
    name: '运单列表',
    cAhref: `${sc}mj/toWaybill.do?yynid=`,
  }, */
];
